import Contact from '../sections/Contact';
import CTA from '../sections/CTA';

export default function ContactPage() {
  return (
    <>
      <div className="page-top-spacer" />
      <Contact />
      <CTA />
    </>
  );
}
